import type { ShortDaysOfWeek } from '@brighterly/lib-core-types/options/enums'
import type { ScheduleStore, AvailableSlot, WeeklyScheduleSlot } from './interfaces'
import type { TutorAvailability } from '@brighterly/lib-core-types/discipline/types'

import { useDisciplineStore } from '@stores/discipline'

const removeWeeklyScheduleDay = (state: ScheduleStore, day: ShortDaysOfWeek): void => {
  state.weeklySchedule = state.weeklySchedule.filter(item => item.day !== day)
}

const removeSelectedDays = (state: ScheduleStore, day: ShortDaysOfWeek): void => {
  state.selectedDays = state.selectedDays.filter(selectedDay => selectedDay !== day)
}

export const actions = {
  setLoading (this: ScheduleStore, payload: boolean): void {
    this.loading = payload
  },
  setModalSchedule (this: ScheduleStore, payload: boolean): void {
    this.modalSchedule = payload
  },
  setModalScheduleSuccess (this: ScheduleStore, payload: boolean): void {
    this.modalScheduleSuccess = payload
  },
  setModalConfirmWeeklySchedule (this: ScheduleStore, payload: boolean): void {
    this.modalConfirmWeeklySchedule = payload
  },
  setAvailableSlots (this: ScheduleStore, payload: AvailableSlot[]): void {
    this.availableSlots = payload
  },
  setSelectedDate (this: ScheduleStore, payload: string | null): void {
    this.selectedDate = payload
    // Clear time selection and validation when date changes
    this.selectedTime = null
    this.timeMode = 'normal'
  },
  setSelectedTime (this: ScheduleStore, payload: string | null): void {
    this.selectedTime = payload
    if (payload) {
      this.timeMode = 'normal'
    }
  },
  setTimeMode (this: ScheduleStore, payload: 'normal' | 'error'): void {
    this.timeMode = payload
  },
  resetForm (this: ScheduleStore): void {
    this.selectedDate = null
    this.selectedTime = null
    this.timeMode = 'normal'
  },
  setAvailability (this: ScheduleStore, payload: TutorAvailability | null): void {
    const disciplineStore = useDisciplineStore()

    if (disciplineStore.isEla) {
      this.availabilityEla = payload
    } else if (disciplineStore.isMath) {
      this.availabilityMath = payload
    }
  },
  setWeeklySchedule (this: ScheduleStore, payload: WeeklyScheduleSlot[]): void {
    this.weeklySchedule = payload

    this.selectedDays = [...new Set(payload.map(slot => slot.day))]
  },
  setWeeklyScheduleItemToggle (this: ScheduleStore, payload: WeeklyScheduleSlot): void {
    const exists = this.weeklySchedule.some(
      item => item.day === payload.day && item.start_time === payload.start_time,
    )
    if (exists) {
      this.weeklySchedule = this.weeklySchedule.filter(
        item => item.day !== payload.day || item.start_time !== payload.start_time,
      )
    } else {
      this.weeklySchedule = [...this.weeklySchedule, payload]
    }
  },
  toggleSelectedDay (this: ScheduleStore, day: ShortDaysOfWeek): void {
    if (this.selectedDays.includes(day)) {
      removeWeeklyScheduleDay(this, day)
      removeSelectedDays(this, day)
    } else {
      this.selectedDays = [...this.selectedDays, day]
    }
  },
  setShowErrors (this: ScheduleStore, payload: boolean): void {
    this.showErrors = payload
  },
}
